import { FC } from "react";
import { Outlet } from "react-router-dom";

import { ErrorBoundary } from "@dzambalaorg/mui-page-layout";
import { GlobalFormDialog, GlobalViewDialog } from "@framework/shared";
import { AppShellLayout } from "@dzambalaorg/ui-kit";

import { Header } from "../header";
import { marketGlobalDialogComponentsSchema } from "../../../shared";

export const Layout: FC = () => {
  return (
    <AppShellLayout header={<Header />}>
      <AppShellLayout.Main>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </AppShellLayout.Main>
      <GlobalFormDialog externalDialogComponentSchema={marketGlobalDialogComponentsSchema} />
      <GlobalViewDialog externalDialogComponentSchema={marketGlobalDialogComponentsSchema} />
    </AppShellLayout>
  );
};
